/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import { KeyList } from "../../data/interfaces";
import { mapAndAddKeyToKeyList } from '../../data/utils';
import {
    FETCH_KEYS_REQUEST, FETCH_KEYS_SUCCESS, FETCH_KEYS_FAILURE, AppKeysAction,
    CREATE_KEYS_REQUEST, CREATE_KEYS_SUCCESS, CREATE_KEYS_FAILURE, CreateAppKeysAction,
    UPDATE_KEYS_REQUEST, UPDATE_KEYS_SUCCESS, UPDATE_KEYS_FAILURE, UpdateAppKeysAction,
    CREATE_OAUTH_TOKEN_REQUEST, CREATE_OAUTH_TOKEN_SUCCESS, CREATE_OAUTH_TOKEN_FAILURE, CreateOauthTokenAction,
    CREATE_APIKEY_REQUEST, CREATE_APIKEY_SUCCESS, CREATE_APIKEY_FAILURE, CreateApiKeyAction, 
    MAP_APPLICATION_KEY_REQUEST, MAP_APPLICATION_KEY_SUCCESS, MAP_APPLICATION_KEY_FAILURE, ApplicationKeyMappingAction,
    CREATE_API_TEST_KEY_REQUEST, CreateApiTestKeyAction, CREATE_API_TEST_KEY_SUCCESS, CREATE_API_TEST_KEY_FAILURE
} from '../types/applicationKeys';

const initialState = {
    isLoading: false,
    currentKey: null,
    keys: null,
    error: null,
    oauthToken: { accessToken: '', tokenScopes: [], validityTime: 0 },
    isTokenGenerating: false,
    isTokenGenerationSuccess: false,
    apiKey: { apikey: '', validityTime: 0 },
    isApikeyGenerating: false,
    isApikeyGenerationSuccess: false,
    isKeyMappingSuccess: false,
    isKeyMapping: false,
    isKeyUpdating: false,
}

const applicationKeysReducer = (state = initialState, action: AppKeysAction | CreateAppKeysAction |
                                UpdateAppKeysAction | CreateOauthTokenAction | CreateApiKeyAction
                                | ApplicationKeyMappingAction | CreateApiTestKeyAction) => {
    switch (action.type) {
        case FETCH_KEYS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case FETCH_KEYS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                currentKey: (action.payload as KeyList).list[0],
                keys: action.payload
            }
        case FETCH_KEYS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case CREATE_KEYS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_KEYS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                currentKey: action.payload,
                keys: mapAndAddKeyToKeyList(action.payload, state.keys)
            }
        case CREATE_KEYS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case UPDATE_KEYS_REQUEST:
            return {
                ...state,
                isLoading: true,
                isKeyUpdating: true
            }
        case UPDATE_KEYS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isKeyUpdating: false,
                currentKey: action.payload,
                keys: mapAndAddKeyToKeyList(action.payload, state.keys)
            }
        case UPDATE_KEYS_FAILURE:
            return {
                ...state,
                isLoading: false,
                isKeyUpdating: false,
                error: action.payload
            }
        case CREATE_OAUTH_TOKEN_REQUEST:
            return {
                ...state,
                isTokenGenerating: true
            };
        case CREATE_OAUTH_TOKEN_SUCCESS:
            return {
                ...state,
                isTokenGenerating: false,
                isTokenGenerationSuccess: true,
                oauthToken: action.payload
            };
        case CREATE_OAUTH_TOKEN_FAILURE:
            return {
                ...state,
                isTokenGenerating: false,
                isTokenGenerationSuccess: false,
                error: action.payload
            };
        case CREATE_APIKEY_REQUEST:
            return {
                ...state,
                isApikeyGenerating: true
            };
        case CREATE_APIKEY_SUCCESS:
            return {
                ...state,
                isApikeyGenerating: false,
                isApikeyGenerationSuccess: true,
                apiKey: action.payload
            };
        case CREATE_APIKEY_FAILURE:
            return {
                ...state,
                isApikeyGenerating: false,
                isApikeyGenerationSuccess: false,
                error: action.payload
            };
        case MAP_APPLICATION_KEY_REQUEST:
            return {
                ...state,
                isKeyMapping: true,
                isLoading: true,
            };
        case MAP_APPLICATION_KEY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isKeyMappingSuccess: true,
                isKeyMapping: false,
                currentKey: action.payload,
            };
        case MAP_APPLICATION_KEY_FAILURE:
            return {
                ...state,
                isLoading: false,
                isKeyMappingSuccess: false,
                error: action.payload
            };
        case CREATE_API_TEST_KEY_REQUEST:
            return {
                ...state,
                isApikeyGenerating: true
            };
        case CREATE_API_TEST_KEY_SUCCESS:
            return {
                ...state,
                isApikeyGenerating: false,
                isApikeyGenerationSuccess: true,
                apiKey: action.payload
            };
        case CREATE_API_TEST_KEY_FAILURE:
            return {
                ...state,
                isApikeyGenerating: false,
                isApikeyGenerationSuccess: false,
                error: action.payload
            };
        default:
            return state
    }
}

export default applicationKeysReducer;
